import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AlertTriangle, LogOut, Shield, Clock } from 'lucide-react'
import { removeAuthToken } from '../config/api'

const TokenExpiredModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      // Modal açıldığında body scroll'unu engelle
      document.body.style.overflow = 'hidden'
      
      // 10 saniye sonra otomatik olarak login sayfasına yönlendir
      const timer = setTimeout(() => {
        handleLogout()
      }, 10000)

      return () => {
        clearTimeout(timer)
        document.body.style.overflow = 'unset'
      }
    }
  }, [isOpen])

  const handleLogout = () => {
    removeAuthToken()
    navigate('/admin/login')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={handleLogout}></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <AlertTriangle className="h-6 w-6 text-red-600" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Oturum Süresi Doldu
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Güvenlik nedeniyle oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.
                  </p>
                  <div className="mt-3 flex items-center justify-center sm:justify-start text-xs text-gray-400">
                    <Clock className="h-4 w-4 mr-1" />
                    <span>10 saniye sonra otomatik olarak yönlendirileceksiniz</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={handleLogout}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors duration-200"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Giriş Sayfasına Git
            </button>
            <button
              type="button"
              onClick={handleLogout}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-colors duration-200"
            >
              <Shield className="h-4 w-4 mr-2" />
              Şimdi Çıkış Yap
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TokenExpiredModal
